import Circuit from '../../../components/vehicle/circuit'
import CircuitStore from '../../../components/vehicle/circuit/context/context'

const CircuitPage = () => {
  return (
    <CircuitStore>
      <Circuit />
    </CircuitStore>
  )
}
export default CircuitPage
